/**
 * @generated SignedSource<<43ac854e7f99ef9656ad8612ffb6dee6>>
 * @relayHash ad92e795622d6de9e1b7bc6f40d3d2ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da2a1dbde5d2de465037f15dba705bf7edb931eac1f1e6aacc343d41dd51cd09

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type IssueNavigatorDetailedViewPaginationQuery$variables = {
  after?: string | null | undefined;
  amountOfColumns?: number | null | undefined;
  before?: string | null | undefined;
  fieldSetIds: ReadonlyArray<string>;
  fieldSetsContext?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  filterId?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  namespace?: string | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  projectKey?: string | null | undefined;
  projectKeys?: ReadonlyArray<string> | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  shouldQueryFieldSetsById: boolean;
  viewId?: string | null | undefined;
};
export type IssueNavigatorDetailedViewPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_detailedViewData">;
  } | null | undefined;
};
export type IssueNavigatorDetailedViewPaginationQuery = {
  response: IssueNavigatorDetailedViewPaginationQuery$data;
  variables: IssueNavigatorDetailedViewPaginationQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": bulkOpsInNinEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import bulkOpsInNinEnabled_provider from '@atlassian/jira-relay-provider/src/is-bulk-ops-in-nin-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscInfiniteScrollEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-infinite-scroll-enabled.relayprovider';
import isRenderJiraWatchesFieldNINEnabled_provider from '@atlassian/jira-relay-provider/src/is-render-jirawatchesfield-nin.relayprovider';
import isJiraSingleLineRowHeightEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-row-height-enabled.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsContext"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKeys"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryFieldSetsById"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v18 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "kind": "ScalarField",
  "name": "id"
},
v21 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "options",
    "variableName": "options"
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  }
],
v22 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v23 = {
  "kind": "ScalarField",
  "name": "key"
},
v24 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v25 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v26 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v27 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v20/*: any*/)
  ]
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/),
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v27/*: any*/),
        (v20/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v29 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "name"
},
v31 = {
  "kind": "ScalarField",
  "name": "__id"
},
v32 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "amountOfColumns"
},
v33 = {
  "kind": "ScalarField",
  "name": "type"
},
v34 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v35 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraIssueField"
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v30/*: any*/),
                (v20/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v37 = {
  "kind": "ScalarField",
  "name": "value"
},
v38 = [
  (v37/*: any*/),
  (v20/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v39 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v40 = {
  "kind": "ClientExtension",
  "selections": [
    (v39/*: any*/)
  ]
},
v41 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v42 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v43 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v44 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v45 = {
  "kind": "ScalarField",
  "name": "text"
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    (v45/*: any*/),
    (v30/*: any*/),
    (v40/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v47 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v48 = [
  (v47/*: any*/)
],
v49 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v20/*: any*/)
  ]
},
v50 = [
  (v49/*: any*/)
],
v51 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v52 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v37/*: any*/)
  ]
},
v53 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v54 = {
  "kind": "ScalarField",
  "name": "picture"
},
v55 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v56 = {
  "kind": "ClientExtension",
  "selections": [
    (v31/*: any*/)
  ]
},
v57 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "concreteType": "JiraCascadingOption",
          "kind": "LinkedField",
          "name": "cascadingOption",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "parentOptionValue",
              "plural": false,
              "selections": (v38/*: any*/)
            },
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "childOptionValue",
              "plural": false,
              "selections": (v38/*: any*/)
            }
          ]
        },
        (v40/*: any*/)
      ],
      "type": "JiraCascadingSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "args": (v41/*: any*/),
          "concreteType": "JiraComponentConnection",
          "kind": "LinkedField",
          "name": "selectedComponentsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraComponentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraComponent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v42/*: any*/),
                    (v43/*: any*/),
                    (v20/*: any*/)
                  ]
                }
              ]
            }
          ],
          "storageKey": "selectedComponentsConnection(first:1000)"
        },
        (v40/*: any*/)
      ],
      "type": "JiraComponentsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v44/*: any*/),
        (v30/*: any*/),
        (v40/*: any*/)
      ],
      "type": "JiraDateTimePickerField"
    },
    (v46/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraCommentSummary",
          "kind": "LinkedField",
          "name": "commentSummary",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canAddComment"
            },
            (v47/*: any*/)
          ]
        }
      ],
      "type": "JiraCommentSummaryField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "kind": "ScalarField",
          "name": "uri"
        },
        (v40/*: any*/)
      ],
      "type": "JiraUrlField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "fieldOptions",
          "plural": false,
          "selections": (v48/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "fieldOption",
          "plural": false,
          "selections": [
            (v37/*: any*/),
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v50/*: any*/)
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v50/*: any*/)
            },
            (v20/*: any*/),
            (v51/*: any*/)
          ]
        },
        (v40/*: any*/)
      ],
      "type": "JiraSingleSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "selectedOptions",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOptionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraOption",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    (v37/*: any*/),
                    (v51/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        (v40/*: any*/)
      ],
      "type": "JiraMultipleSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "selectedOptions",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOptionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                (v52/*: any*/)
              ]
            }
          ]
        },
        (v40/*: any*/)
      ],
      "type": "JiraCheckboxesField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "concreteType": "JiraUserConnection",
          "kind": "LinkedField",
          "name": "selectedUsersConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v19/*: any*/),
                    (v53/*: any*/),
                    (v30/*: any*/),
                    (v54/*: any*/),
                    (v20/*: any*/),
                    (v55/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "email"
                        }
                      ],
                      "type": "AtlassianAccountUser"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v40/*: any*/)
      ],
      "type": "JiraMultipleSelectUserPickerField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "concreteType": "JiraTeamView",
          "kind": "LinkedField",
          "name": "selectedTeam",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jiraSuppliedId"
            },
            {
              "kind": "ScalarField",
              "name": "jiraSuppliedName"
            }
          ]
        },
        (v40/*: any*/)
      ],
      "type": "JiraTeamViewField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraTimeTrackingField",
              "kind": "LinkedField",
              "name": "timeTrackingField",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                {
                  "concreteType": "JiraEstimate",
                  "kind": "LinkedField",
                  "name": "originalEstimate",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "timeInSeconds"
                    }
                  ]
                },
                {
                  "concreteType": "JiraTimeTrackingSettings",
                  "kind": "LinkedField",
                  "name": "timeTrackingSettings",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "workingHoursPerDay"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "workingDaysPerWeek"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "defaultFormat"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "defaultUnit"
                    }
                  ]
                },
                (v25/*: any*/),
                (v30/*: any*/),
                (v33/*: any*/),
                (v40/*: any*/)
              ]
            },
            (v20/*: any*/)
          ]
        }
      ],
      "type": "JiraOriginalTimeEstimateField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "selectedOption",
          "plural": false,
          "selections": [
            {
              "alias": "label",
              "kind": "ScalarField",
              "name": "value"
            },
            (v20/*: any*/),
            (v42/*: any*/)
          ]
        },
        (v40/*: any*/)
      ],
      "type": "JiraRadioSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "args": (v41/*: any*/),
          "concreteType": "JiraVersionConnection",
          "kind": "LinkedField",
          "name": "selectedVersionsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraVersionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraVersion",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    (v30/*: any*/),
                    (v42/*: any*/),
                    (v43/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "versionId"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "selectedVersionsConnection(first:1000)"
        },
        (v40/*: any*/)
      ],
      "type": "JiraMultipleVersionPickerField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            (v20/*: any*/)
          ]
        },
        {
          "args": (v41/*: any*/),
          "concreteType": "JiraGoalConnection",
          "kind": "LinkedField",
          "name": "selectedGoals",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGoalEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGoal",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    (v23/*: any*/)
                  ]
                }
              ]
            },
            (v56/*: any*/)
          ],
          "storageKey": "selectedGoals(first:1000)"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            (v31/*: any*/),
            (v39/*: any*/)
          ]
        }
      ],
      "type": "JiraGoalsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "args": (v41/*: any*/),
          "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
          "kind": "LinkedField",
          "name": "confluenceRemoteIssueLinks",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraConfluenceRemoteIssueLink",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "href"
                    }
                  ]
                }
              ]
            },
            (v47/*: any*/)
          ],
          "storageKey": "confluenceRemoteIssueLinks(first:1000)"
        },
        (v40/*: any*/)
      ],
      "type": "JiraConfluenceRemoteIssueLinksField"
    }
  ]
},
v58 = {
  "kind": "ScalarField",
  "name": "message"
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            (v58/*: any*/)
          ]
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v60 = [
  (v30/*: any*/),
  (v20/*: any*/)
],
v61 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "componentsOld",
          "concreteType": "JiraComponentConnection",
          "kind": "LinkedField",
          "name": "selectedComponentsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraComponentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraComponent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v60/*: any*/)
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraComponentsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v45/*: any*/)
      ],
      "type": "JiraSingleLineTextField"
    }
  ]
},
v62 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "date"
    },
    (v30/*: any*/),
    (v62/*: any*/),
    (v40/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v64 = {
  "kind": "InlineFragment",
  "selections": [
    (v44/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v65 = {
  "kind": "ScalarField",
  "name": "summary"
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraEpic",
      "kind": "LinkedField",
      "name": "epic",
      "plural": false,
      "selections": [
        (v23/*: any*/),
        (v65/*: any*/),
        {
          "kind": "ScalarField",
          "name": "color"
        },
        (v20/*: any*/)
      ]
    }
  ],
  "type": "JiraEpicLinkField"
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        (v26/*: any*/),
        (v20/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        {
          "kind": "ScalarField",
          "name": "statusId"
        },
        (v27/*: any*/),
        (v20/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v41/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v30/*: any*/),
                (v49/*: any*/)
              ]
            }
          ]
        },
        (v47/*: any*/)
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v30/*: any*/),
    (v40/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v71 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v72 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v71/*: any*/),
        (v30/*: any*/),
        (v20/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v73 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v20/*: any*/)
  ]
},
v74 = {
  "concreteType": "JiraColorField",
  "kind": "LinkedField",
  "name": "issueColorField",
  "plural": false,
  "selections": [
    (v49/*: any*/),
    (v20/*: any*/)
  ]
},
v75 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v76 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v75/*: any*/),
        (v30/*: any*/),
        (v20/*: any*/)
      ]
    },
    (v20/*: any*/)
  ]
},
v77 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v23/*: any*/),
        (v73/*: any*/),
        (v20/*: any*/)
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v74/*: any*/),
            (v76/*: any*/),
            (v73/*: any*/),
            (v20/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v74/*: any*/),
            (v76/*: any*/),
            (v73/*: any*/),
            (v20/*: any*/),
            (v24/*: any*/),
            (v77/*: any*/),
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "ids",
                  "value": [
                    "summary",
                    "issuetype",
                    "status"
                  ]
                }
              ],
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fieldsById",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v19/*: any*/),
                        (v20/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v25/*: any*/),
                            (v45/*: any*/)
                          ],
                          "type": "JiraSingleLineTextField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v25/*: any*/),
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "issueTypeId"
                                },
                                (v30/*: any*/),
                                (v75/*: any*/),
                                (v29/*: any*/),
                                (v20/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        (v28/*: any*/)
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
            }
          ]
        },
        (v30/*: any*/),
        (v40/*: any*/)
      ]
    }
  ],
  "type": "JiraParentIssueField"
},
v79 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        },
        (v20/*: any*/)
      ]
    },
    (v30/*: any*/),
    (v40/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v80 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        (v23/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v20/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": (v60/*: any*/)
    }
  ],
  "type": "JiraResolutionField"
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "sprintId"
                },
                (v30/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "state"
                },
                {
                  "kind": "ScalarField",
                  "name": "endDate"
                }
              ]
            }
          ]
        }
      ]
    },
    (v30/*: any*/),
    (v40/*: any*/)
  ],
  "type": "JiraSprintField"
},
v83 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v53/*: any*/),
        (v54/*: any*/),
        (v30/*: any*/),
        (v20/*: any*/),
        (v55/*: any*/)
      ]
    },
    (v30/*: any*/),
    (v62/*: any*/),
    (v40/*: any*/)
  ],
  "type": "JiraSingleSelectUserPickerField"
},
v84 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*: any*/),
    {
      "args": (v41/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v60/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    }
  ],
  "type": "JiraMultipleVersionPickerField"
},
v85 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraAdfToConvertedPlainText",
              "kind": "LinkedField",
              "name": "convertedPlainText",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "plainText"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v86 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        (v75/*: any*/),
        (v20/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v87 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v47/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v77/*: any*/),
                    (v23/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v19/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v27/*: any*/)
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v20/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    (v20/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v20/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v88 = {
  "kind": "ScalarField",
  "name": "number"
},
v89 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "formatStyle"
        },
        {
          "kind": "ScalarField",
          "name": "formatUnit"
        }
      ]
    }
  ]
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v88/*: any*/),
    (v30/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        (v88/*: any*/),
        (v89/*: any*/)
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v88/*: any*/),
        (v30/*: any*/),
        (v89/*: any*/),
        (v40/*: any*/)
      ]
    },
    (v40/*: any*/)
  ],
  "type": "JiraNumberField"
},
v91 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        {
          "concreteType": "JiraGroupConnection",
          "kind": "LinkedField",
          "name": "selectedGroupsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    (v30/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "groupId"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v40/*: any*/)
      ],
      "type": "JiraMultipleGroupPickerField"
    }
  ]
},
v92 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraFlag",
          "kind": "LinkedField",
          "name": "flag",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFlagged"
            }
          ]
        }
      ],
      "type": "JiraFlagField"
    }
  ]
},
v93 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraWatch",
          "kind": "LinkedField",
          "name": "watch",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "isWatching"
            }
          ]
        }
      ],
      "type": "JiraWatchesField"
    }
  ]
},
v94 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v48/*: any*/)
},
v95 = [
  {
    "concreteType": "JiraIssueFieldSetEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssueFieldSet",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v33/*: any*/),
          (v34/*: any*/),
          {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v25/*: any*/),
                      (v33/*: any*/),
                      (v35/*: any*/),
                      (v20/*: any*/),
                      (v36/*: any*/),
                      (v57/*: any*/),
                      (v59/*: any*/),
                      (v61/*: any*/),
                      (v63/*: any*/),
                      (v64/*: any*/),
                      (v66/*: any*/),
                      (v67/*: any*/),
                      (v46/*: any*/),
                      (v68/*: any*/),
                      (v69/*: any*/),
                      (v70/*: any*/),
                      (v72/*: any*/),
                      (v78/*: any*/),
                      (v79/*: any*/),
                      (v80/*: any*/),
                      (v81/*: any*/),
                      (v82/*: any*/),
                      (v83/*: any*/),
                      (v84/*: any*/),
                      (v85/*: any*/),
                      (v86/*: any*/),
                      (v87/*: any*/),
                      (v90/*: any*/),
                      (v91/*: any*/),
                      (v92/*: any*/),
                      (v93/*: any*/)
                    ]
                  }
                ]
              },
              (v94/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v96 = {
  "kind": "ScalarField",
  "name": "pageNumber"
},
v97 = {
  "kind": "ScalarField",
  "name": "isCurrent"
},
v98 = [
  (v96/*: any*/),
  (v22/*: any*/),
  (v97/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueNavigatorDetailedViewPaginationQuery",
    "selections": [
      {
        "args": (v18/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
              },
              {
                "kind": "Variable",
                "name": "projectKeys",
                "variableName": "projectKeys"
              }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_detailedViewData"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v8/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "IssueNavigatorDetailedViewPaginationQuery",
    "selections": [
      {
        "args": (v18/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v21/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isResolved"
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                  "status"
                                ]
                              }
                            ],
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v28/*: any*/),
                                      (v20/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "fieldsById(ids:[\"status\"])"
                          },
                          {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  (v29/*: any*/),
                                  (v20/*: any*/)
                                ]
                              },
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v30/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              (v31/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isHighlightedIssueRow"
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "condition": "shouldQueryFieldSetsById",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "args": [
                                      {
                                        "kind": "Variable",
                                        "name": "fieldSetIds",
                                        "variableName": "fieldSetIds"
                                      },
                                      (v32/*: any*/)
                                    ],
                                    "concreteType": "JiraIssueFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSetsById",
                                    "plural": false,
                                    "selections": (v95/*: any*/)
                                  }
                                ]
                              },
                              {
                                "condition": "shouldQueryFieldSetsById",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                  {
                                    "args": [
                                      {
                                        "kind": "Variable",
                                        "name": "context",
                                        "variableName": "fieldSetsContext"
                                      },
                                      {
                                        "kind": "Variable",
                                        "name": "filterId",
                                        "variableName": "filterId"
                                      },
                                      (v32/*: any*/),
                                      {
                                        "kind": "Variable",
                                        "name": "namespace",
                                        "variableName": "namespace"
                                      },
                                      {
                                        "kind": "Variable",
                                        "name": "viewId",
                                        "variableName": "viewId"
                                      }
                                    ],
                                    "concreteType": "JiraIssueFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSetsForIssueSearchView",
                                    "plural": false,
                                    "selections": (v95/*: any*/)
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v65/*: any*/),
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v71/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v19/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 500
                          }
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v19/*: any*/),
                                              (v25/*: any*/),
                                              (v33/*: any*/),
                                              (v35/*: any*/),
                                              (v20/*: any*/),
                                              (v36/*: any*/),
                                              (v57/*: any*/),
                                              (v59/*: any*/),
                                              (v61/*: any*/),
                                              (v63/*: any*/),
                                              (v64/*: any*/),
                                              (v66/*: any*/),
                                              (v67/*: any*/),
                                              (v46/*: any*/),
                                              (v68/*: any*/),
                                              (v69/*: any*/),
                                              (v70/*: any*/),
                                              (v72/*: any*/),
                                              (v78/*: any*/),
                                              (v79/*: any*/),
                                              (v80/*: any*/),
                                              (v81/*: any*/),
                                              (v82/*: any*/),
                                              (v83/*: any*/),
                                              (v84/*: any*/),
                                              (v85/*: any*/),
                                              (v86/*: any*/),
                                              (v87/*: any*/),
                                              (v90/*: any*/),
                                              (v91/*: any*/),
                                              (v92/*: any*/),
                                              (v93/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOptions",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOptionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          (v52/*: any*/),
                                                          (v56/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraCheckboxesField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "fieldOption",
                                                    "plural": false,
                                                    "selections": [
                                                      (v51/*: any*/),
                                                      (v20/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraSingleSelectField"
                                              },
                                              (v56/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      (v94/*: any*/)
                                    ]
                                  },
                                  (v56/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "fieldSets(first:500)"
                      },
                      (v56/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "startCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasPreviousPage"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraIssueNavigatorPageInfo",
                    "kind": "LinkedField",
                    "name": "issueNavigatorPageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastIssuePosition"
                      }
                    ]
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                      }
                    ],
                    "concreteType": "JiraPageCursors",
                    "kind": "LinkedField",
                    "name": "pageCursors",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": (v98/*: any*/)
                      },
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": (v98/*: any*/)
                      },
                      {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v96/*: any*/),
                          (v97/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "pageCursors(maxCursors:7)"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalIssueSearchResultCount"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "issueSearchError",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "messages"
                          }
                        ],
                        "type": "JiraInvalidJqlError"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v58/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "errorType"
                          }
                        ],
                        "type": "JiraInvalidSyntaxError"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "jql"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isCappingIssueSearchResult"
                  },
                  (v56/*: any*/)
                ]
              },
              {
                "args": (v21/*: any*/),
                "filters": [
                  "issueSearchInput"
                ],
                "handle": "connection",
                "key": "IssueNavigatorDetailedViewPagination__issues",
                "kind": "LinkedHandle",
                "name": "issues"
              }
            ],
            "type": "JiraDetailedView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "da2a1dbde5d2de465037f15dba705bf7edb931eac1f1e6aacc343d41dd51cd09",
    "metadata": {},
    "name": "IssueNavigatorDetailedViewPaginationQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": bulkOpsInNinEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};
})();

(node as any).hash = "b55231f2326f70fb819ca3062e0201a6";

export default node;
